<template>
	<div class="cursor">
		<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16">
			<path ref="path" fill="#fff" d="M8,0.4a7.6000000000000005,7.6000000000000005,0,1,0,0,15.200000000000001a7.6000000000000005,7.6000000000000005,0,0,0,0,-15.200000000000001zm3.12,9.904a0.5920000000000001,0.5920000000000001,0,0,1,0,0.8320000000000001c-0.11199999999999999,0.11199999999999999,-0.272,0.17600000000000002,-0.41600000000000004,0.17600000000000002c-0.14400000000000002,0,-0.304,-0.064,-0.41600000000000004,-0.17600000000000002L8,8.832L5.696000000000001,11.120000000000001c-0.11199999999999999,0.11199999999999999,-0.272,0.17600000000000002,-0.41600000000000004,0.17600000000000002s-0.304,-0.064,-0.41600000000000004,-0.17600000000000002a0.5920000000000001,0.5920000000000001,0,0,1,0,-0.8320000000000001L7.167999999999999,8L4.88,5.696000000000001a0.5920000000000001,0.5920000000000001,0,0,1,0,-0.8320000000000001a0.5920000000000001,0.5920000000000001,0,0,1,0.8320000000000001,0L8,7.167999999999999l2.3040000000000003,-2.3040000000000003a0.5920000000000001,0.5920000000000001,0,0,1,0.8320000000000001,0a0.5920000000000001,0.5920000000000001,0,0,1,0,0.8320000000000001L8.832,8l2.2880000000000003,2.3040000000000003z"/>
		</svg>
	</div>
</template>

<script>

export default {
	data() {
		return {
			currentCursorIndex: 0
		}
	},
	computed: {
		currentCursor: function() {
			return this.$store.getters['ui/cursor']
		},
		mousePosition: function() {
			return this.$store.getters['ui/mousePosition']
		}
	},
	watch: {
		'currentCursor': function(cursor, prevCursor) {
			if (cursor === 'default') {
				this.hideCursor()
				document.body.classList.remove('no-cursor')
			} else {
				document.body.classList.add('no-cursor')
				this.showCursor()
			}
		},
		'mousePosition': function(position) {
			this.updateCursorPosition()
		}
	},
	mounted() {
		this.updateCursorPosition()
	},
	methods: {
		updateCursorPosition() {
			TweenMax.set(this.$el, {
				x: this.mousePosition.x,
				y: this.mousePosition.y,
				xPercent: -50,
				yPercent: -50
			})
		},
		showCursor() {
			document.body.classList.add('no-cursor')
			TweenMax.to(this.$el, 0.5, {
				scale: 1,
				overwrite: 'all',
				ease: Elastic.easeOut.config(1, 0.75)
			})
		},
		hideCursor() {
			TweenMax.to(this.$el, 0.3, {
				scale: 0,
				overwrite: 'all',
				ease: Power4.easeOut,
				onComplete: () => {
					document.body.classList.remove('no-cursor')
				}
			})
		}
	}
}
</script>

<style lang="sass">
.cursor
	position: fixed
	z-index: 7
	top: 0
	left: 0
	pointer-events: none
	transform: scale(0)
	svg
		width: 4.5rem
		filter: drop-shadow( 0px 0px 5px rgba(170, 170, 170, 0.5) );

</style>



// WEBPACK FOOTER //
// src/components/Cursor.vue